/* cáene Mugler-preview — R02 (sections/R02/WHITE-HEADER-TASK.md 2026-09-10,
   rättad enligt REORDER-FIX-TASK.md 2026-09-11).
   Ägs uteslutande av Claude B under R02. Laddas ENDAST från
   sections/header.liquid, och bara när headern körs i transparent läge.

   Beslutat beteende: headerfältet är TRANSPARENT med SILENCE endast så länge
   heron täcker hela headerbandet, och VIT med CLAY i alla andra lägen. Vitt är
   default hela vägen ned: utan JS, utan hero, på alla sidtyper utan hero och
   före den här komponentens första bedömning. Transparensen kräver att
   attributet data-caene-tone="dark" aktivt sätts här, och sätts inte längre av
   Liquid på förhand.

   Det här ersätter den tidigare lösningen med mörka tonzoner i dual och
   campaign och den separata observern som dolde deras copy. Båda behövdes bara
   så länge navigationen kunde ligga över foto längre ned på sidan. Med vit
   header efter heron finns varken tonproblemet eller textkollisionen kvar, så
   koden för dem är borttagen i stället för avstängd. Innehåll får nu passera
   naturligt bakom den vita headern och döljs aldrig i förtid.

   Mätning: TVÅ IntersectionObservers och, ENDAST i temaeditorn, en passiv
   scrolllyssnare (se scheduleToneCheck). Roten är krympt med rootMargin till
   ett 1 px högt band vid headerfältets ÖVERKANT respektive NEDERKANT. Båda tittar på samma hero och anropar samma callback. Villkoret
   för transparens är att heron överlappar båda banden, alltså att den täcker
   hela fältet; de två linjerna är exakt de ställen där det villkoret kan byta
   värde, i båda riktningarna.

   Tidigare fanns bara det nedre bandet. Det räckte så länge heron låg först på
   sidan och bara kunde lämna fältet nedåt, men inte när heron flyttas längre
   ned och i stället glider IN i fältet uppifrån: dess underkant korsar då
   aldrig den nedre linjen, ingen callback utlöses och tonen blir hängande ljus
   trots att fältet är helt täckt (reproducerat i REORDER-FIX-TASK.md).

   Observers är bara billiga förändringsdetektorer; själva villkoret räknas i
   heroCoversField(), som anropas från både den synkrona förstabedömningen och
   callbacken, så de aldrig kan säga olika saker. Det är därför editor-
   fallbacken kan läggas till utan att något mäts på ett andra sätt: den ber
   bara om samma bedömning.

   Livscykel: connectedCallback/disconnectedCallback + AbortController, alla
   observers rivs tillsammans, customElements.get()-skydd. Bygger om vid
   resize, orientationchange och shopify:section:load|unload|reorder. Native
   StickyHeader (sections/header.liquid) är orörd. */
(function () {
  if (window.customElements === undefined) return;
  if (customElements.get('caene-header-tone')) return;

  // Heron märks redan med sitt scrim (sections/caene-mugler-hero.liquid).
  // Scrimmet ligger inset:0 i sektionen, så de två har samma box; sektionen är
  // reserv om ett hero någon gång renderas utan scrim.
  const HERO_SELECTORS = ['.caene-mugler-hero__scrim', '.caene-mugler-hero'];

  // Sant bara inne i Shopifys temaeditor. Plattformen sätter flaggan i
  // content_for_header, alltså i <head> och före den här deferrade filen.
  function isDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  class CaeneHeaderTone extends HTMLElement {
    connectedCallback() {
      // Försvar mot dubbla lyssnare om elementet flyttas i stället för att
      // rivas. Nollställer även tonen; rebuild() nedan sätter rätt värde
      // synkront i samma task, så ingen ruta hinner ritas däremellan.
      this.disconnectedCallback();

      this.wrapper = this.closest('.header-wrapper');
      this.field = this.closest('.shopify-section') || this.wrapper;
      if (!this.wrapper || !this.field) return;

      this.rebuildFrame = 0;
      this.toneFrame = 0;
      this.observers = [];
      this.onIntersect = this.onIntersect.bind(this);
      this.scheduleRebuild = this.scheduleRebuild.bind(this);
      this.scheduleToneCheck = this.scheduleToneCheck.bind(this);

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      window.addEventListener('resize', this.scheduleRebuild, options);
      window.addEventListener('orientationchange', this.scheduleRebuild, options);
      // Temaeditorn river och återskapar innehållssektioner utan sidladdning,
      // så heron kan tillkomma, försvinna eller byta plats.
      document.addEventListener('shopify:section:load', this.scheduleRebuild, options);
      document.addEventListener('shopify:section:unload', this.scheduleRebuild, options);
      document.addEventListener('shopify:section:reorder', this.scheduleRebuild, options);
      // Endast i temaeditorn, och endast som extra utlösare. Se
      // scheduleToneCheck(). Butiken får ingen scrolllyssnare alls.
      if (isDesignMode()) {
        window.addEventListener('scroll', this.scheduleToneCheck, {
          passive: true,
          signal: this.controller.signal,
        });
      }

      this.rebuild();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
      this.disconnectObservers();
      if (this.rebuildFrame) cancelAnimationFrame(this.rebuildFrame);
      this.rebuildFrame = 0;
      if (this.toneFrame) cancelAnimationFrame(this.toneFrame);
      this.toneFrame = 0;
      this.hero = null;
      // Transparensen får aldrig överleva komponenten. Rivs den — headern
      // laddas om, transparensen stängs av i temaeditorn, heron tas bort —
      // ska headern falla tillbaka till sitt vita default.
      if (this.wrapper) this.wrapper.setAttribute('data-caene-tone', 'light');
    }

    scheduleRebuild() {
      if (this.rebuildFrame) return;
      this.rebuildFrame = requestAnimationFrame(() => {
        this.rebuildFrame = 0;
        if (this.isConnected) this.rebuild();
      });
    }

    /* Editor-fallback: en extra UTLÖSARE, inte en andra mätning.

       I fristående preview räcker de två banden; den flyttade heron växlar i
       båda riktningarna. Inne i temaeditorns iframe observerade Codex
       2026-09-11 (iframe 1132x554, fält [0, 89], scroll 0/452/485/552/452) att
       ingen av de två observers utlöste vid scroll, medan heroCoversField() i
       samma ögonblick räknade fram sant. Ett försök med explicit
       root: document gav samma resultat, och browsern var långsam under
       experimentet. Den exakta plattformsorsaken är alltså INTE fastställd.
       Det här är en fallback mot ett observerat symptom, inte en rättning av
       en bevisad orsak — därför är den avsiktligt trubbig och liten.

       Observers rivs inte i editorn. Utlöser de ändå är apply() redan en
       no-op vid oförändrat värde, så de två kan inte dra åt olika håll: båda
       vägarna läser samma geometri i det ögonblick de körs.

       Kostnaden är en rAF per scrollburst och en enda getBoundingClientRect
       per frame, i editorn. Butiken rör inte den här koden. */
    scheduleToneCheck() {
      if (this.toneFrame) return;
      this.toneFrame = requestAnimationFrame(() => {
        this.toneFrame = 0;
        // En frame som redan låg i kö när komponenten revs får aldrig
        // återinföra transparensen efter disconnectedCallback().
        if (!this.isConnected) return;
        this.onIntersect();
      });
    }

    /* Headerfältets faktiska geometri, aldrig ett hårdkodat värde: höjden är
       olika per brytpunkt (89/75/59 px på startsidan, 90/76/60 utanför den där
       separatorkantens bredd ingår i boxen) och rect.top är inte alltid 0. */
    fieldBox() {
      const viewport = window.innerHeight || document.documentElement.clientHeight || 0;
      const width = document.documentElement.clientWidth || window.innerWidth || 0;
      if (viewport < 2 || width < 1) return null;

      const rect = this.field.getBoundingClientRect();
      if (!rect.height) return null;

      const top = Math.min(Math.max(Math.round(rect.top), 0), viewport);
      const bottom = Math.min(Math.max(Math.round(rect.bottom), 0), viewport);
      if (bottom <= top) return null;

      return { top: top, bottom: bottom, viewport: viewport, width: width };
    }

    /* --header-height synkas här, INTE i Dawns StickyHeader (som inte får
       röras). Native setHeaderHeight() körs bara vid init och vid växling av
       matchMedia('(max-width: 989px)'), så en resize mellan två storlekar som
       båda ligger under 989 — 768 → 390, där headern går från 75 till 59 px —
       lämnar variabeln kvar på det gamla värdet. Samma element och samma
       offsetHeight som native använder, så de två kan aldrig skriva olika
       värden. */
    syncHeaderHeight() {
      const height = this.field.offsetHeight;
      if (!height) return;
      const value = height + 'px';
      const root = document.documentElement;
      if (root.style.getPropertyValue('--header-height') === value) return;
      root.style.setProperty('--header-height', value);
    }

    findHero() {
      for (let i = 0; i < HERO_SELECTORS.length; i += 1) {
        const hero = document.querySelector(HERO_SELECTORS[i]);
        if (hero) return hero;
      }
      return null;
    }

    /* Enda villkoret för transparens, använt av både den synkrona
       förstabedömningen och båda observers callback.

       Villkoret är formulerat så att det är ORDAGRANT "heron överlappar båda
       banden nedan", inget mer och inget mindre:
         övre bandet  [field.top, field.top + 1)       → rect.top < field.top + 1
         nedre bandet [field.bottom, field.bottom + 1) → rect.bottom > field.bottom
       Det är hela poängen med de två banden. Varje gång någon av de två
       delarna kan byta värde korsar heron ett av banden, och då utlöses en
       callback som räknar om villkoret här. Ett strängare villkor (t.ex.
       rect.top <= field.top) skulle kunna slå om utan att något band korsas,
       och headern skulle bli hängande i fel läge. */
    heroCoversField(field) {
      if (!this.hero || !field) return false;
      const rect = this.hero.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return false;
      if (rect.right <= 0 || rect.left >= field.width) return false;
      return rect.top < field.top + 1 && rect.bottom > field.bottom;
    }

    /* En observer per bandlinje. IntersectionObserver har EN rootMargin, så
       två linjer kräver två observers; båda tittar på samma hero och anropar
       samma callback. Ingen av dem gör något arbete under scroll — de utlöses
       bara vid själva korsningen.

       Varför båda behövs: med bara det nedre bandet räcker det att heron är
       hög för att dess underkant aldrig ska korsa linjen, och då utlöses ingen
       callback alls medan heron glider upp och täcker fältet. Det är exakt det
       reproducerade felet när heron flyttas efter produkter (heroTop 82,36 →
       32,36 → −2,64 → −67,64 vid 1280x720: fältet blir täckt, men tonen står
       kvar som ljus). Det övre bandet fångar just den korsningen, i båda
       riktningarna. */
    addBand(line, field) {
      if (line < 0 || line + 1 > field.viewport) return;
      const observer = new IntersectionObserver(this.onIntersect, {
        rootMargin: -line + 'px 0px ' + -(field.viewport - line - 1) + 'px 0px',
      });
      observer.observe(this.hero);
      this.observers.push(observer);
    }

    disconnectObservers() {
      if (!this.observers) {
        this.observers = [];
        return;
      }
      this.observers.forEach((observer) => observer.disconnect());
      this.observers.length = 0;
    }

    rebuild() {
      this.disconnectObservers();

      this.syncHeaderHeight();
      this.hero = this.findHero();

      const field = this.fieldBox();
      this.apply(this.heroCoversField(field));

      if (!this.hero || !field) return;

      this.addBand(field.top, field);
      this.addBand(field.bottom, field);
    }

    onIntersect() {
      this.apply(this.heroCoversField(this.fieldBox()));
    }

    apply(dark) {
      if (!this.wrapper) return;
      const value = dark ? 'dark' : 'light';
      if (this.wrapper.getAttribute('data-caene-tone') === value) return;
      this.wrapper.setAttribute('data-caene-tone', value);
    }
  }

  customElements.define('caene-header-tone', CaeneHeaderTone);
})();
